import React from 'react';
import styled from '@emotion/styled';
import { Css } from '@/ui';
import { IAsset } from '../../../../contentful';
import { Color } from '../../../../styles/Color';
import Suitcase from '../../../../assets/icons/suitcase.svg';

interface IEmployerLogoProps {
	employerLogo?: IAsset;
	employerName: string;
}

export default function EmployerLogo({
	employerLogo,
	employerName,
}: IEmployerLogoProps) {
	return (
		<EmployerLogoWrapper hasLogo={!!employerLogo}>
			{employerLogo ? (
				<img
					src={employerLogo?.fields.file.url}
					alt={employerLogo?.fields.title || `${employerName} logo`}
					width="100%"
					height="100%"
					loading="lazy"
				/>
			) : (
				<Suitcase aria-label={`${employerName} logo not available`} />
			)}
		</EmployerLogoWrapper>
	);
}

export const EmployerLogoWrapper = styled.div<{ hasLogo: boolean }>`
	overflow: hidden;
	${({ hasLogo }) => !hasLogo && `background: ${Color.Neutral94}`};
	width: ${Css.pxToRem(44)};
	height: ${Css.pxToRem(44)};
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: ${Css.pxToRem(44)};
	border-radius: 6px;

	img {
		border-radius: 6px;
	}

	svg {
		path {
			fill: ${Color.Neutral70};
		}
	}
`;
